import React, { useEffect, useState } from "react"
import Rating from "react-rating"
import { IoStarSharp } from "react-icons/io5"
import styled from "styled-components"

const RatingReview = ({ funcOnClick, initRating }) => {
  const lable = {
    0: "Beri bintang!",
    1: "Belum sesuai",
    2: "Kurang sesuai",
    3: "Cukup sesuai",
    4: "Sesuai",
    5: "Sangat sesuai",
  }

  const [showLable, setShowLable] = useState(lable[0])
  const [rating, setRating] = useState(initRating)

  const handleHover = value => {
    if (value == null) {
      setShowLable(lable[0])
      setRating(initRating)
    } else {
      setRating(value)
      setShowLable(lable[value])
    }
  }

  useEffect(() => {
    setRating(initRating)
  }, [initRating])

  return (
    <Styled>
      <Rating
        fullSymbol={<IoStarSharp color="#F9C115" size={35} className="star" />}
        emptySymbol={<IoStarSharp color="grey" size={35} className="star" />}
        initialRating={initRating}
        onHover={value => handleHover(value)}
        onClick={funcOnClick}
      />

      <div className="lable">{rating ? lable[rating] : showLable}</div>
    </Styled>
  )
}

const Styled = styled.div`
  .lable {
    font-size: 16px;
    padding-top: 3px;
  }
  .star {
    padding: 0px 3px;
  }

  @media only screen and (max-width: 767.98px) {
    .lable {
      font-size: 12px;
    }
  }
`

export default RatingReview
